// extracted by mini-css-extract-plugin
export default {"home":"Home_home__JXOYx","home__info-text":"Home_home__info-text__Wt6MD"};